<script lang="ts">
    import {exists} from 'shared/utils/custom-utils';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';

    export let selected = false;
    export let highlightStyle: 'success' | 'danger' | 'accent-blue' | null = null;
    export let hoverTooltip: string | null = null;
</script>

<tr class="kp-table-selectable-row {exists(highlightStyle) ? `highlight-${highlightStyle}` : ''}"
    tabindex="0"
    use:tooltip={{content: hoverTooltip ?? '', role: 'tooltip', enabled: exists(hoverTooltip)}}
    class:row-selected={selected}
    on:click>

    <slot/>
</tr>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";

    .kp-table-selectable-row {
        position: relative;
        isolation: isolate;
        cursor: pointer;

        &:after {
            content: '';
            position: absolute;
            top: 2px;
            bottom: 2px;
            left: calc(@spacing-m * -1);
            right: calc(@spacing-m * -1);
            width: calc(100% + @spacing-m * 2);
            z-index: -1;
            border-radius: @border-radius-large;
            background-color: transparent;
            outline: 2px solid transparent;
            transition: background-color 0.2s ease-in-out, outline-color 0.2s ease-in-out;
        }

        &:hover:after {
            background-color: @themed-panel-bg;
        }

        &.row-selected:after {
            background-color: @themed-body-bg-blue-highlighted;
            outline-color: var(--accent-blue-new);
        }

        &.highlight-success:after {
            background-color: #E7F7EE;
        }

        &.highlight-danger:after {
            background-color: #FFEEF5;
        }

        &.highlight-accent-blue:after {
            background-color: @themed-body-bg-blue-highlighted;
        }
    }
</style>